export const STS20001 = "STS20001";   // Aguardando Pagamento
export const STS20002 = "STS20002";   // Pago
export const STS20003 = "STS20003";   // Reprovado
export const STS20004 = "STS20004";   // Processamento de Pagamento
export const STS25001 = "STS25001";   // CARRINHO
export const STS20005 = "STS20005";   // Estornado
export const STS20006 = "STS20006";   // Cancelado
export const STS25002 = "STS25002";   // Aguardando Validação
export const STS25003 = "STS25003";   // Aprovado
